"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTextStyleToJSON = exports.transformJSONToTextStyle = void 0;

require("core-js/modules/es.function.name.js");

var _colorData = require("./color-data");

var _resourceSource = require("./resource-source");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformTextStyleToJSON = function transformTextStyleToJSON(value) {
  return {
    id: value.id,
    name: value.name,
    created: value.created,
    postscript_name: value.postscriptName,
    font_family: value.fontFamily,
    font_size: value.fontSize,
    font_weight: value.fontWeight,
    font_style: value.fontStyle,
    font_stretch: value.fontStretch,
    line_height: value.lineHeight,
    letter_spacing: value.letterSpacing,
    text_align: value.textAlign,
    color: value.color && (0, _colorData.transformColorDataToJSON)(value.color),
    source: value.source && (0, _resourceSource.transformResourceSourceToJSON)(value.source)
  };
};

exports.transformTextStyleToJSON = transformTextStyleToJSON;

var transformJSONToTextStyle = function transformJSONToTextStyle(value) {
  return {
    id: value.id,
    name: value.name,
    created: value.created,
    postscriptName: value.postscript_name,
    fontFamily: value.font_family,
    fontSize: value.font_size,
    fontWeight: value.font_weight,
    fontStyle: value.font_style,
    fontStretch: value.font_stretch,
    lineHeight: value.line_height,
    letterSpacing: value.letter_spacing,
    textAlign: value.text_align,
    color: value.color && (0, _colorData.transformJSONToColorData)(value.color),
    source: value.source && (0, _resourceSource.transformJSONToResourceSource)(value.source)
  };
};
/**
 * 
 * @export
 * @interface TextStyle
 */


exports.transformJSONToTextStyle = transformJSONToTextStyle;